import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { AllSoakingSampleTestReponseModel, LogIdRequest, SoakingSampleTestReponseModel } from '@gtpl/shared-models/production-management';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { Raw, Repository } from 'typeorm';
import { SoakingSampleTestAdapter } from '../dto/soaking-sample-test-adapter';
import { SoakingSampleTestDTO } from '../dto/soaking-sample-test.dto';
import { SoakingSampleTest } from '../entities/soaking-sample-test.entity';
import { CommonResponse } from '@gtpl/shared-models/masters';

@Injectable()
export class SoakingSampleTestService {

  constructor(
    @InjectRepository(SoakingSampleTest)
    private repository: Repository<SoakingSampleTest>,
    private adapter: SoakingSampleTestAdapter,

  ) { }

  async createSoakingSampleTest(dto: SoakingSampleTestDTO, isUpdate: boolean): Promise<SoakingSampleTestReponseModel> {

    try {

      const convertedEntity: SoakingSampleTest = this.adapter.convertDtoToEntity(dto, isUpdate);
      const savedEntity: SoakingSampleTest = await this.repository.save(
        convertedEntity
      );

      if (savedEntity) {
        // generating resposnse
        const response = new SoakingSampleTestReponseModel(true, 1, isUpdate ? 'SoakingSampleTest Updated Successfully' : 'SoakingSampleTest Created Successfully');
        return response;

      } else {
        //return new InformationMessageError(11106, "State saved but issue while transforming into DTO");
        throw new ErrorResponse(11106, 'SoakingSampleTest saved but issue while transforming into DTO');
      }
    } catch (error) {
      // when error occures while saving the data , the execution will come to catch block.
      // tslint:disable-next-line: typedef
      return error;
    }
  }


  async getSamplesInfoBylogId(Req: LogIdRequest): Promise<AllSoakingSampleTestReponseModel> {
    try {
      //retrieves all companies
      const dto:SoakingSampleTestDTO[]=[]
      const entities: SoakingSampleTest[] = await this.repository.find({
          where:{logId:Req.productionLogid}
          });
          
         
          if (entities) {
            entities.forEach(sample =>{
              const gradingMonDto:SoakingSampleTestDTO = this.adapter.convertEntityToDto(sample)
              dto.push(gradingMonDto)
            })
              const response = new AllSoakingSampleTestReponseModel(true, 11101 , 'Samples retrived Successfully',dto);
              return response;
          }
          else{
              throw new ErrorResponse(11106,'Something went wrong');
          }
          // generating resposnse
  } catch (err) {
      return err;
  }
}



}

